export const SECTION_CONFIG = {
  sectionTitle: {
    title: 'Title & Category',
    order: 1
  },
  sectionFeatures: {
    title: 'Type & Features',
    order: 2
  },
  sectionDescriptions: {
    title: 'Description & Objectives',
    order: 3
  },
  sectionAudience: {
    title: 'Audience',
    order: 4
  },
  sectionInfo: {
    title: 'Additional Info',
    order: 5
  },
  sectionThumbnails: {
    title: 'Generate Thumbnails',
    order: 6
  }
};

export const FIELD_CONFIG = {
  // Section 1: Title & Category
  title: {
    section: 'sectionTitle',
    required: true,
    defaultValue: ''
  },
  portalTitle: {
    section: 'sectionTitle',
    required: false,
    defaultValue: null
  },
  vendor: {
    section: 'sectionTitle',
    required: true,
    defaultValue: 'VinciWorks'
  },
  suiteTitle: {
    section: 'sectionTitle',
    required: true,
    defaultValue: ''
  },
  topicTitle: {
    section: 'sectionTitle',
    required: true,
    defaultValue: ''
  },
  subtopicId: {
    section: 'sectionTitle',
    required: false,
    defaultValue: []
  },
  subtopicTitle: {
    section: 'sectionTitle',
    required: false,
    defaultValue: []
  },

  // Section 2: Type & Features
  activityName: {
    section: 'sectionFeatures',
    required: true,
    defaultValue: ''
  },
  'resourceMaster.CompletionCriteria': {
    section: 'sectionFeatures',
    required: true,
    defaultValue: null
  },
  passMark: {
    section: 'sectionFeatures',
    required: true, // Conditionally required in logic
    defaultValue: 0
  },
  level: {
    section: 'sectionFeatures',
    required: true,
    defaultValue: ''
  },
  duration: {
    section: 'sectionFeatures',
    required: true,
    defaultValue: ''
  },
  accredited: {
    section: 'sectionFeatures',
    required: false,
    defaultValue: ''
  },
  'additionalInfo.CourseFeatures': {
    section: 'sectionFeatures',
    required: false,
    defaultValue: []
  },
  hkcpdHours: {
    section: 'sectionFeatures',
    required: false,
    defaultValue: null
  },
  hkrmeHours: {
    section: 'sectionFeatures',
    required: false,
    defaultValue: null
  },

  // Section 3: Description & Objectives
  tagline: {
    section: 'sectionDescriptions',
    required: true,
    defaultValue: '<p>Write a short summary for marketing</p>'
  },
  description: {
    section: 'sectionDescriptions',
    required: true,
    defaultValue: '<p>Write a course summary</p>'
  },
  shortDescription: {
    section: 'sectionDescriptions',
    required: true,
    defaultValue:
      '<p>Write a short course summary for marketing and the website.</p>'
  },
  objectives: {
    section: 'sectionDescriptions',
    required: true,
    defaultValue:
      '<ul><li>Learning objective 1</li><li>Learning objective 2</li></ul>'
  },
  howTaken: {
    section: 'sectionDescriptions',
    required: true,
    defaultValue: '<p>How does this fit in a learning plan?</p>'
  },

  // Section 4: Audience
  'additionalInfo.Industry': {
    section: 'sectionAudience',
    required: true,
    defaultValue: ''
  },
  'additionalInfo.industryId': {
    section: 'sectionAudience',
    required: false,
    defaultValue: ''
  },
  'resourceMaster.TargetLearners': {
    section: 'sectionAudience',
    required: true,
    defaultValue: []
  },
  'additionalInfo.Jurisdiction': {
    section: 'sectionAudience',
    required: true,
    defaultValue: []
  },
  'additionalInfo.jurisdictionId': {
    section: 'sectionAudience',
    required: false,
    defaultValue: []
  },

  // Section 5: Additional Info
  'resourceMaster.PresentersBio': {
    section: 'sectionInfo',
    required: true,
    defaultValue:
      'This course was written and designed by VinciWorks with input and feedback from leading experts in the field.'
  },
  'resourceMaster.Version': {
    section: 'sectionInfo',
    required: true,
    defaultValue: 'Current'
  },
  'resourceMaster.CourseversionID': {
    section: 'sectionInfo',
    required: false,
    defaultValue: null
  },
  retired: {
    section: 'sectionInfo',
    required: false,
    defaultValue: false
  },
  replacedBy: {
    section: 'sectionInfo',
    required: false,
    defaultValue: null
  },
  flagship: {
    section: 'sectionInfo',
    required: true,
    defaultValue: 'false'
  },
  'additionalInfo.triggerWarning': {
    section: 'sectionInfo',
    required: true,
    defaultValue: false
  },
  'additionalInfo.qualityIndex': {
    section: 'sectionInfo',
    required: false,
    defaultValue: null
  },
  'additionalInfo.ExcludeFromDemo': {
    section: 'sectionInfo',
    required: true,
    defaultValue: false
  },
  'additionalInfo.groupCourseId': {
    section: 'sectionInfo',
    required: false,
    defaultValue: null
  },
  'additionalInfo.relatedTo': {
    section: 'sectionInfo',
    required: false,
    defaultValue: []
  },
  'additionalInfo.redundancy': {
    section: 'sectionInfo',
    required: false,
    defaultValue: []
  },
  'additionalInfo.legislation': {
    section: 'sectionInfo',
    required: false,
    defaultValue: null
  }
};
